export var ShippingActionTypes;
(function (ShippingActionTypes) {
    ShippingActionTypes["FETCH_SHIPPING_FEES_ATTEMPT"] = "FETCH_SHIPPING_FEES_ATTEMPT";
    ShippingActionTypes["FETCH_SHIPPING_FEES_SUCCESS"] = "FETCH_SHIPPING_FEES_SUCCESS";
    ShippingActionTypes["FETCH_SHIPPING_FEES_FAILURE"] = "FETCH_SHIPPING_FEES_FAILURE";
    ShippingActionTypes["FETCH_PUDOS_ATTEMPT"] = "FETCH_PUDOS_ATTEMPT";
    ShippingActionTypes["FETCH_PUDOS_SUCCESS"] = "FETCH_PUDOS_SUCCESS";
    ShippingActionTypes["FETCH_PUDOS_FAILURE"] = "FETCH_PUDOS_FAILURE";
})(ShippingActionTypes || (ShippingActionTypes = {}));
